import React, { useState } from 'react'
import PropTypes from 'prop-types'
import exact from 'prop-types-exact'
import classnames from 'classnames'
import {
  voteItem,
  ITEM_VOTE_TYPE_UP,
  ITEM_VOTE_TYPE_NEUTRAL,
  ITEM_VOTE_TYPE_DOWN,
} from './itemsActions'
import './itemVotingWidget.pcss'
import LoginPromptBubble from '../util/LoginPromptBubble'

const ItemVotingWidget = ({
  currentVote,
  plusVotes,
  minusVotes,
  dispatch,
  loggedIn,
  itemId,
}) => {

  const [showLoginPrompt, setShowLoginPrompt] = useState(false)

  const isUpvoted = currentVote === ITEM_VOTE_TYPE_UP
  const isDownvoted = currentVote === ITEM_VOTE_TYPE_DOWN


  const handleVoteClick = (voteType) => {
    if (loggedIn) {
      dispatch(voteItem(itemId, voteType))
    } else {
      setShowLoginPrompt(true)
    }
  }

  const handleVoteUpClick = () => {
    handleVoteClick(ITEM_VOTE_TYPE_UP)
  }

  const handleVoteNeutralClick = () => {
    handleVoteClick(ITEM_VOTE_TYPE_NEUTRAL)
  }

  const handleVoteDownClick = () => {
    handleVoteClick(ITEM_VOTE_TYPE_DOWN)
  }

  const handleLoginPromptDismiss = () => {
    setShowLoginPrompt(false)
  }

  // https://fontawesome.com/v5/icons/thumbs-up?f=classic&s=regular
  // https://fontawesome.com/v5/icons/thumbs-down?f=classic&s=regular
  return (
    <div className='item-actions-vote-container'>
      <p className='sr-only'>Äänestä uutista</p>

      { /* Negative votes */ }
      <button
        type='button'
        className={ classnames('item-vote-button', {'item-vote-button--downvoted': isDownvoted}) }
        onClick={ isDownvoted ? handleVoteNeutralClick : handleVoteDownClick }
        role='switch'
        aria-checked={ isDownvoted }
      >
        <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' width='18' height='18'>
          <path d='M466.3 225.3c4.7-22.6 .9-44.5-9-63 3-23.9-4-48.6-17.3-67C439 39.4 404.1 0 327 0c-7 0-15 0-22.2 0C201.2 0 169 40 128 40h-10.8c-5.6-5-13-8-21.2-8H32C14.3 32 0 46.3 0 64v240c0 17.7 14.3 32 32 32h64c11.8 0 22.2-6.4 27.7-16h7.1c19.1 17 46 60.7 68.8 83.4 13.7 13.7 10.2 108.6 71.8 108.6 57.6 0 95.3-31.9 95.3-104.7 0-18.4-3.9-33.7-8.9-46.5h36.5c48.6 0 85.8-41.6 85.8-85.6 0-19.2-5-35-13.7-49.8zM64 296c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm330.2 16.7H290.2c0 37.8 28.4 55.4 28.4 94.5 0 23.8 0 56.7-47.3 56.7-18.9-18.9-9.5-66.2-37.8-94.5C206.9 342.9 167.3 272 138.9 272H128V85.8c53.6 0 100-37.8 171.6-37.8h37.8c35.5 0 60.8 17.1 53.1 65.9 15.2 8.2 26.5 36.4 13.9 57.6 21.6 20.4 18.7 51.1 5.2 65.6 9.5 0 22.4 18.9 22.3 37.8-.1 18.9-16.7 37.8-37.8 37.8z' />
        </svg>
        <span className='sr-only'>Negatiivinen ääni</span>
        <span className='item-votes'>{ minusVotes }</span>
      </button>

      { /* Positive votes */ }
      <button
        type='button'
        className={ classnames('item-vote-button', {'item-vote-button--upvoted': isUpvoted}) }
        onClick={ isUpvoted ? handleVoteNeutralClick : handleVoteUpClick }
        role='switch'
        aria-checked={ isUpvoted }
      >
        <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' width='18' height='18'>
          <path d='M466.3 286.7C475 271.8 480 256 480 236.9c0-44-37.2-85.6-85.8-85.6H357.7c4.9-12.8 8.9-28.1 8.9-46.5C366.6 31.9 328.9 0 271.3 0c-61.6 0-58.1 94.9-71.8 108.6-22.7 22.7-49.6 66.4-68.8 83.4H32c-17.7 0-32 14.3-32 32v240c0 17.7 14.3 32 32 32h64c14.9 0 27.4-10.2 31-24 44.5 1 75.1 39.9 177.8 39.9 7.2 0 15.2 0 22.2 0 77.1 0 112-39.4 112.9-95.3 13.3-18.4 20.3-43.1 17.3-67 9.9-18.5 13.7-40.3 9-63zm-61.8 53.8c12.6 21.1 1.3 49.4-13.9 57.6 7.7 48.8-17.6 65.9-53.1 65.9h-37.8c-71.6 0-118-37.8-171.6-37.8V240h10.9c28.4 0 68-70.9 94.5-97.5 28.4-28.4 18.9-75.6 37.8-94.5 47.3 0 47.3 33 47.3 56.7 0 39.2-28.4 56.7-28.4 94.5h104c21.1 0 37.7 18.9 37.8 37.8 .1 18.9-12.8 37.8-22.3 37.8 13.5 14.6 16.4 45.2-5.2 65.6zM88 432c0 13.3-10.7 24-24 24s-24-10.7-24-24 10.7-24 24-24 24 10.7 24 24z' />
        </svg>
        <span className='sr-only'>Positiivinen ääni</span>
        <span className='item-votes'>{ plusVotes }</span>
      </button>

      { showLoginPrompt && (
        <LoginPromptBubble
          message='Ole hyvä ja kirjaudu äänestääksesi'
          dispatch={ dispatch }
          onDismiss={ handleLoginPromptDismiss }
        />
      ) }
    </div>
  )
}

ItemVotingWidget.propTypes = exact({
  minusVotes: PropTypes.number.isRequired,
  plusVotes: PropTypes.number.isRequired,
  itemId: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
  loggedIn: PropTypes.bool.isRequired,
  currentVote: PropTypes.oneOf([
    ITEM_VOTE_TYPE_UP,
    ITEM_VOTE_TYPE_NEUTRAL,
    ITEM_VOTE_TYPE_DOWN,
  ]).isRequired,
})

export default ItemVotingWidget
